'use strict';

/**
 * sex
 * 性别
 * @param str
 * @param mode
 * 0 [0-男,1-女]
 * 1 [1-男,2-女]
 * 2 {m:'男',f:'女'}
 * @returns {*}
 */
module.exports = function (str) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  console.log('sex fillter 参数', str, mode);
  if (str === undefined) return "";

  switch (mode) {
    case 0:
      return ['男', '女'][str];
      break;

    case 1:
      return ['', '男', '女'][str];
      break;

    case 2:
      if (!str) {
        return "";
      }
      str = str.toLowerCase();
      return { m: '男', f: '女' }[str];
      break;
  }
};